export default __webpack_public_path__ + "static/media/Classwin_Menu_pop_up_8-Package.38e0bce9.jpg";